import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { formatDate } from "../../utilities/formatters";

const DrawdownChart = (DrawdownData) => {
  const [series, setSeries] = useState([
    {
      name: "Drawdown(Percentage)",
      data: [],
    },
  ]);

  const [options, setOptions] = useState({
    colors: ["#04d9ff"],
    fill: {
      colors: "#04d9ff",
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 3,
      colors: ["transparent"],
    },
    labels: [],
    xaxis: {
      // type: "datetime",
      tickPlacement: "on",
      // categories:[],
      axisTicks: {
        show: false,
      },
      labels: {
        formatter: (value) => {
          return `${formatDate(value)} ${new Date(value).toLocaleTimeString()}`;
        },
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      // title: {
      //     text: '$ (thousands)'
      // },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
        formatter: (value) => Number(value).toFixed(2),
      },
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    // fill: {
    //     opacity: 1
    // },
    tooltip: {
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
    },
  });

  useEffect(() => {
    if (DrawdownData && DrawdownData.DrawDown) {
      const Data = DrawdownData.DrawDown["draw_down"].map((data) => data) || [];
      const Dates = DrawdownData.DrawDown["date"].map((data) => data) || [];
      setSeries([
        {
          name: "Drawdown(Percentage)",
          type: "column",
          data: Data,
        },
      ]);

      setOptions({
        ...options,
        labels: Dates,
      });
    }
  }, [DrawdownData]);

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={290}
      />
    </div>
  );
};
export default DrawdownChart;
